/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_FormInputs */

const en_ui_chart_series_form = /** @type {(inputs: Ui_Chart_Series_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Form (TSB)`)
};

const de_ui_chart_series_form = /** @type {(inputs: Ui_Chart_Series_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Form (TSB)`)
};

/**
* | output |
* | --- |
* | "Form (TSB)" |
*
* @param {Ui_Chart_Series_FormInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_form = /** @type {((inputs?: Ui_Chart_Series_FormInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_FormInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_form(inputs)
	return de_ui_chart_series_form(inputs)
});